export const SUPPORTES_PLATFORMS = {
  ANDROID: 'android',
  IOS: 'ios',
} as const;

type IsMobileReturnValue = {
  isMobile: boolean;
  platform?: (typeof SUPPORTES_PLATFORMS)[keyof typeof SUPPORTES_PLATFORMS];
};

const ANDROID_REGEX = /android/i;
const IOS_REGEX = /iPad|iPhone/;

function getPossibleMobilePlatformInformation(): IsMobileReturnValue {
  const userAgent = navigator.userAgent;

  if (ANDROID_REGEX.test(userAgent)) {
    return {
      isMobile: true,
      platform: SUPPORTES_PLATFORMS.ANDROID,
    };
  } else if (IOS_REGEX.test(userAgent)) {
    return {
      isMobile: true,
      platform: SUPPORTES_PLATFORMS.IOS,
    };
  } else {
    return {
      isMobile: false,
    };
  }
}

export default getPossibleMobilePlatformInformation;
